module.exports = __webpack_public_path__ + "static/media/adhocLogo.df7962b9.jpeg";